// libs
import React, { memo } from 'react';

interface CameraProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

function Camera({ width = 21, height = 19, fill = 'none', className = '' }: CameraProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 19"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Iconly/Light-Outline/Camera">
        <g id="Camera">
          <path
            id="Combined-Shape"
            d="M13.8174 0.945976C14.401 1.17828 14.8137 1.597 15.1836 2.21087L15.3055 2.42273L15.7578 3.28988L15.7726 3.3141L15.7862 3.33518L15.8246 3.38768C16.0306 3.61218 16.3754 3.74781 16.603 3.74781C18.6878 3.74781 20.3905 5.38507 20.4949 7.44335L20.5 7.64381V13.4388C20.5 16.1108 18.3898 18.2913 15.7455 18.4042L15.53 18.4088H5.47C2.79734 18.4088 0.617471 16.2989 0.504592 13.6544L0.5 13.4388V7.64381C0.5 5.4924 2.24498 3.74781 4.397 3.74781C4.62377 3.74781 4.96908 3.61199 5.17544 3.38768L5.18255 3.3793L5.19145 3.36764L5.24287 3.28876L5.69382 2.42301C6.09577 1.69248 6.53303 1.20414 7.18188 0.945882C8.37089 0.473102 12.6293 0.473102 13.8174 0.945976ZM7.73635 2.33964C7.51496 2.42776 7.31452 2.63172 7.10062 2.98531L7.00802 3.14611L6.62316 3.89021L6.52843 4.06164C6.44936 4.19317 6.37026 4.3042 6.27995 4.4026C5.81953 4.90306 5.15847 5.19211 4.57082 5.24053L4.397 5.24781L4.2329 5.25334C3.03997 5.334 2.08621 6.28754 2.00553 7.47981L2 7.64381V13.4388C2 15.2911 3.45174 16.8048 5.27961 16.9037L5.47 16.9088H15.53C17.3819 16.9088 18.896 15.4565 18.9949 13.6291L19 13.4388V7.64381C19 6.37603 18.0142 5.33767 16.7671 5.25334L16.603 5.24781L16.4289 5.24053C15.8403 5.1921 15.1793 4.90297 14.7194 4.40194C14.6303 4.30484 14.5517 4.1946 14.473 4.06418L14.4542 4.03185L14.4317 3.9917L14.3156 3.77395L13.9917 3.14639C13.7729 2.74928 13.5726 2.50659 13.3564 2.38462L13.2626 2.33964L13.1433 2.29997C12.1142 2.00909 8.53441 2.02231 7.73635 2.33964ZM10.4997 6.79051C12.6699 6.79051 14.4287 8.5493 14.4287 10.7195C14.4287 12.8897 12.6699 14.6485 10.4997 14.6485C8.32949 14.6485 6.5707 12.8897 6.5707 10.7195C6.5707 8.5493 8.32949 6.79051 10.4997 6.79051ZM10.4997 8.29051C9.15791 8.29051 8.0707 9.37772 8.0707 10.7195C8.0707 12.0613 9.15791 13.1485 10.4997 13.1485C11.8415 13.1485 12.9287 12.0613 12.9287 10.7195C12.9287 9.37772 11.8415 8.29051 10.4997 8.29051ZM16.0043 6.09151C16.5566 6.09151 17.0043 6.53922 17.0043 7.09151C17.0043 7.60434 16.6183 8.02702 16.1209 8.08478L16.0043 8.09151C15.443 8.09151 14.9953 7.64379 14.9953 7.09151C14.9953 6.57867 15.3813 6.156 15.8787 6.09824L16.0043 6.09151Z"
            fill="#1B1E21"
          />
        </g>
      </g>
    </svg>
  );
}

export default memo(Camera);
